/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import LatestBlogs from "./LatestBlogs";

const LatestBlogsContainer = ({
  latestBlogs
}) => {
  return (
    <LatestBlogs latestBlogs={latestBlogs} />
  );
};

export default LatestBlogsContainer;
